import React, { useEffect, useState } from "react"; // Import useState
import Sidebar from "../sidebar";
import Topnav from "../TopNav";
import { API_URL, token } from "../config";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { ClipLoader } from 'react-spinners';
import '../Courses/Courses.css'
import { getCurrentDate } from "../Components/DateFunction";
import { useNavigate } from "react-router-dom";

const Results2 = () => {
    const [dataSource, setDataSource] = useState([]);
    const [moduleId] = useState(localStorage.getItem('moduleId'));
    const [levelId] = useState(localStorage.getItem('levelId'));
    const [userId] = useState(localStorage.getItem('userId'));
    const [isAdmin, setIsAdmin] = useState(false);
    const [adminId] = useState(localStorage.getItem('Admin'));
    const [teacherId] = useState(localStorage.getItem('teacher'));
    const [freeTrial, setFreeTrial] = useState(localStorage.getItem('freeTrial') === 'true' ? true : false); // Convert to boolean
    const [showAddModal, setShowAddModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [promo] = useState(localStorage.getItem('PROMO'));

    // Search state for student selection
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredStudents, setFilteredStudents] = useState([]);
    const [students, setStudents] = useState([]);
    // const [studentId, setStudentId] = useState([]);

    const [assignments, setAssignments] = useState([]);
    // const [assignment_id, setAssignment_id] = useState([]);
    const [totalPM, setTotalPM] = useState('');

    const [formData, setFormData] = useState({
        module_id: moduleId,
        student_id: '',
        assignment_id: '',
        marks: '',
        total_possible: '',
        percentage: '',
        grade: ''
    });

    const navigate = useNavigate();
    const [hide, setHide] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            const screeWidth = window.innerWidth;
            if (screeWidth < 768) {
                setHide(true);
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        }

    }, [])

    const toggleSidebar = () => {
        setHide(prevHide => !prevHide); // Toggle the hide state
    };

    useEffect(() => {
        if (localStorage.getItem('sd') !== "true") {
            navigate('/courses')
        }

    }, [])

    const fetchResults = async () => {
        try {
            const response = await fetch(`${API_URL}/results/mod/${moduleId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token()}`
                }
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setDataSource(data);
        } catch (error) {
            console.error("Error fetching colleges:", error);
        }
    };

    const fetchAssignments = async () => {
        try {
            const response = await fetch(`${API_URL}/assignments/mod/${moduleId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token()}`
                }
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setAssignments(data);
        } catch (error) {
            console.error("Error fetching colleges:", error);
        }
    };

    const fetchStudents = async () => {
        const response = await fetch(`${API_URL}/subscriptions/module/mod/${moduleId}/${getCurrentDate()}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token()}`
            }
        });
        const data = await response.json();
        setStudents(data);
        setFilteredStudents(data);
    };

    useEffect(() => {
        fetchResults();
        fetchStudents();
        fetchAssignments();
    }, []);

    const checkSub = async () => {
        //PROMO EDITION        
        if (promo === 'true') {
            console.log("Promo Edition active, no subscription check needed.");
            return
        }
        try {
            const response = await fetch(`${API_URL}/subscriptions/student/${userId}/${levelId}/${getCurrentDate()}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token()}`
                }
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            if (data.length < 1) {
                if (!freeTrial) {
                    navigate('/courses');
                }
            }
            console.log(data.length);
        } catch (error) {
            console.error("Error fetching colleges:", error);
        }
    };

    useEffect(() => {
        const checkAdmin = () => {
            if ((localStorage.getItem('userRole') === "Admin") || userId === teacherId) {
                setIsAdmin(true);
            } else {
                checkSub();
            }
        };

        checkAdmin();
    }, []);

    useEffect(() => {
        const matches = students.filter(student =>
            student.student_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            (student.student_surname && student.student_surname.toLowerCase().includes(searchTerm.toLowerCase()))
        );
        setFilteredStudents(matches);

    }, [searchTerm, students]);

    const openModal = () => {
        setShowAddModal(true);
    };

    useEffect(() => {
        let percentage = (formData.marks / totalPM) * 100;

        setFormData(prevData => ({ ...prevData, total_possible: totalPM }));
        setFormData(prevData => ({ ...prevData, percentage: percentage }));
    }, [totalPM])

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        console.log(formData);

        try {
            // Post results
            const response = await fetch(`${API_URL}/results`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token()}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) throw new Error('Addition failed');
            setShowAddModal(false);
            Swal.fire({
                text: "Posted successfully!",
                icon: "success"
            });

            fetchResults(); // Fetch updated assignments
            resetFormData();
            setIsLoading(false);
        } catch (error) {
            Swal.fire({
                text: error.message || "An error occurred!",
                icon: "error"
            });
            setIsLoading(false);
        }
    }

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        });

        if (result.isConfirmed) {
            try {
                await fetch(`${API_URL}/results/${id}`, {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${token()}`
                    }
                });
                fetchResults();
                Swal.fire({
                    text: "Deleted Successfully!",
                    icon: "success"
                });
            } catch (error) {
                Swal.fire({
                    text: "An error occurred while deleting!",
                    icon: "error"
                });
            }
        }
    };

    const resetFormData = () => {
        setFormData({
            module_id: moduleId,
            student_id: '',
            assignment_id: '',
            marks: '',
            total_possible: '',
            percentage: '',
            grade: ''
        });
    }


    return (
        <html lang="en">

            <body id="page-top">

                <div id="wrapper">

                    <Sidebar hide={hide}></Sidebar>

                    <div id="content-wrapper" className="d-flex flex-column" >
                        <div id="content">

                            <Topnav toggleSidebar={toggleSidebar}></Topnav>

                            <div className="container-fluid" style={{ textAlign: 'left', overflow: 'auto', maxHeight: '85vh' }}>

                                {/* <!-- Page Heading --> */}
                                {!isAdmin ? (
                                    <h1 className="h3 mb-4 text-gray-800">Results</h1>
                                ) : (
                                    <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                        <h1 className="h3 mb-0 text-gray-800">Results</h1>
                                        <button onClick={openModal} className=" d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                                            <i className="fas fa-upload fa-sm text-white-50"></i> Post Results
                                        </button>
                                    </div>
                                )}


                                {/* TABLE TEXT */}
                                <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        <h6 className="m-0 font-weight-bold text-primary">Results Table</h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            <table className="table" id="dataTable" width="100%" cellspacing="0">
                                                <thead>
                                                    <tr>
                                                        <th>Date</th>
                                                        <th>Name</th>
                                                        <th>Surname</th>
                                                        <th>Assignment</th>
                                                        <th>Marks</th>
                                                        <th>Percentage</th>
                                                        <th>Grade</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {dataSource.map((element) => (
                                                        <tr key={element.result_id}>
                                                            <td>{element.date.slice(0, 10)}</td>
                                                            <td>{element.name}</td>
                                                            <td>{element.surname}</td>
                                                            <td>{element.topic}</td>
                                                            <td>{element.marks} / {element.total_possible}</td>
                                                            <td>{element.percentage}%</td>
                                                            <td>{element.grade}</td>
                                                            <td>
                                                                <div className="d-flex align-items-center">
                                                                    <button type="button" className="btn btn-link" onClick={() => handleDelete(element.result_id)}>
                                                                        <FontAwesomeIcon icon={faTrash} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>

                </div>

                {/* Submit Assignment Modal */}
                {showAddModal && (
                    <div className="modal fade show" style={{ display: 'block' }} onClick={() => setShowAddModal(false)}>
                        <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
                            <div className="modal-content" style={{ boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)', borderRadius: '8px' }}>
                                <div className="modal-header">
                                    <h5 className="modal-title">Post Results</h5>
                                    <button type="button" className="close" onClick={() => setShowAddModal(false)}>&times;</button>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div className="modal-body">
                                        <div className="form-group">
                                            <label className="modal-label">Student</label>
                                            <input
                                                type="text"
                                                className="form-control mb-2"
                                                placeholder="Search either by Name or Surname"
                                                style={{ backgroundColor: '#c3f3f580' }}
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />
                                            <select
                                                className="form-control"
                                                // value={studentId}
                                                // onChange={(e) => setStudentId(e.target.value)}
                                                value={formData.student_id}
                                                onChange={(e) => setFormData(prevData => ({ ...prevData, student_id: e.target.value }))}
                                                required
                                            >
                                                <option value="">Select Student</option>
                                                {filteredStudents.map(student => (
                                                    <option key={student.subscription_id} value={student.student_id}>
                                                        {student.student_name} {student.student_surname}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label className="modal-label">Assignment</label>
                                            <select
                                                className="form-control"
                                                // value={assignment_id}
                                                // onChange={(e) => setAssignment_id((e.target.value))}
                                                value={formData.assignment_id}
                                                onChange={(e) => setFormData(prevData => ({ ...prevData, assignment_id: e.target.value }))}
                                                required
                                            >
                                                <option value="">Select Assignment</option>
                                                {assignments.map(assignment => (
                                                    <option key={assignment.assignment_id} value={assignment.assignment_id}>
                                                        {assignment.topic}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label className="modal-label">Marks</label>
                                            <input type="number" className="form-control" value={formData.marks} onChange={(e) => setFormData(prevData => ({ ...prevData, marks: e.target.value }))} required />
                                        </div>
                                        <div className="form-group">
                                            <label className="modal-label">Total Possible Marks</label>
                                            <input type="number" className="form-control" value={totalPM} onChange={(e) => setTotalPM(e.target.value)} required />
                                        </div>
                                        <div className="form-group">
                                            <label className="modal-label">Grade</label>
                                            <input type="text" className="form-control" value={formData.grade} onChange={(e) => setFormData(prevData => ({ ...prevData, grade: e.target.value }))} required />
                                        </div>

                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={() => setShowAddModal(false)}>Close</button>
                                        {isLoading && (
                                            <div style={{ marginTop: '8px', textAlign: 'center' }}>
                                                <div className="btn btn-primary" style={{ width: '5rem' }}>
                                                    <ClipLoader loading={isLoading} size={27} color="white" />
                                                </div>
                                            </div>
                                        )}
                                        {!isLoading && (
                                            <button type="submit" className="btn btn-primary">Submit</button>
                                        )}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )}

            </body>

        </html >
    );


};

export default Results2;